(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
if (!customElements.get('urbbana-footer')) {
  customElements.define('urbbana-footer', class extends HTMLElement {
    connectedCallback() {
      if (this.footerController) return;
      this.footerController = new AbortController();
      const signal = this.footerController.signal;
      const media = window.matchMedia('(max-width: 699px)');
      const toggles = Array.from(this.querySelectorAll('[data-footer-toggle]'));
      const setExpanded = (toggle, expanded) => {
        const panel = this.querySelector('[id="' + toggle.getAttribute('aria-controls') + '"]');
        if (!panel) return;
        toggle.setAttribute('aria-expanded', String(expanded));
        panel.hidden = !expanded;
      };
      const resetLayout = () => toggles.forEach(toggle => setExpanded(toggle, !media.matches));
      toggles.forEach(toggle => {
        toggle.addEventListener('click', () => {
          if (!media.matches) return;
          const shouldOpen = toggle.getAttribute('aria-expanded') !== 'true';
          toggles.forEach(item => setExpanded(item, item === toggle && shouldOpen));
        }, {signal});
      });
      media.addEventListener('change', resetLayout, {signal});
      this.setAttribute('data-footer-ready', '');
      resetLayout();
    }
    disconnectedCallback() {
      this.footerController?.abort();
      this.footerController = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
